
export enum FilterByDto{
  DATE,
  POPULARITY,
  FOLLOW
}
